import { render } from "./Enable2FADialog.vue?vue&type=template&id=ad15ff5e"
import script from "./Enable2FADialog.vue?vue&type=script&lang=js"
export * from "./Enable2FADialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__